import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  Select,
  Row,
  Spin,
  Col,
  Modal,
  Typography,
  Button,
  notification,
  DatePicker,
} from "antd";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Tesseract from "tesseract.js";
import DepartmentsApi from "../../Apis/DepartmentsApi";
import ProductApi from "../../Apis/ProductApi";
import AllergensApi from "../../Apis/AllergensApi";
import {
  AudioOutlined,
  CameraOutlined,
  CameraTwoTone,
  InfoCircleFilled,
  LoadingOutlined,
  PictureOutlined,
  PictureTwoTone,
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import Webcam from "react-webcam";
import dayjs from "dayjs";
import moment from "moment";
import ShelfLifeApi from "../../Apis/ShelfLifeApi";
import CoolingShelfApi from "../../Apis/CoolingShelfApi";
import StorageSuggestionApi from "../../Apis/StorageSuggestionApi";
// import RuntimeConfigsApi from "../../Apis/RuntimeConfigsApi";
import IngredientsApi from "../../Apis/IngredientsApi";
import DepartmentModel from "../../DropDowns/DepartmentModel";
import SupplierModel from "../../DropDowns/SupplierModel";
import AllergenModel from "../../DropDowns/AllergenModel";
import CoolingShelfModel from "../../DropDowns/CoolingShelfModel";
import ShelfLifeModel from "../../DropDowns/ShelfLifeModel";
import StorageSuggestionModel from "../../DropDowns/StorageSuggestionModel";
import UOM1 from "../../DropDowns/Messurements/UOM1";
import UOM2 from "../../DropDowns/Messurements/UOM2";
import UOM3 from "../../DropDowns/Messurements/UOM3";
import StorageListApi from "../../Apis/StorageListApi";
import StorageDropDown from "../../DropDowns/StorageDropDown";
const { Title } = Typography;
function AddProduct({ visible, onClose }) {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formAdd] = Form.useForm();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const CURRENCY = decodedToken?.currency === "USD" ? "$" : "€";
  const [storages2, setStorages2] = React.useState([]);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);

  // const [Departments, setDepartments] = React.useState([]);
  const getDepartments = useCallback(() => {
    DepartmentsApi.ListDepartments(0, 10)
      .then((response) => {
        // setDepartments(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const handleDepartmentChange = (value) => {
    console.log(value)
    setSelectedDepartment(value);
  };

  const [Allergens, setAllergens] = React.useState([]);
  const getAllergens = useCallback(() => {
    AllergensApi.ListAllergensApi(0,100)
      .then((response) => {
        setAllergens(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getStorages = useCallback(() => {
    StorageListApi.ListStorage()
      .then((response) => {
        // console.log(response);
        setStorages2(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const [ShelfLife, setShelfLifes] = React.useState([]);
  const getShelfLifes = useCallback(() => {
    ShelfLifeApi.ListShelfLife(0, 10)
      .then((response) => {
        setShelfLifes(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [CoolingShelfLife, setCoolingShelfLifes] = React.useState([]);
  const getCoolingShelfLifes = useCallback(() => {
    CoolingShelfApi.ListCoolingShelf(0, 10)
      .then((response) => {
        setCoolingShelfLifes(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const [Storages, setStorages] = React.useState([]);
  const getStorage = useCallback(() => {
    StorageSuggestionApi.ListStorage(0, 10)
      .then((response) => {
        setStorages(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const stopWebcamStream = () => {
    const webcamVideo = webcamRef?.current?.video;
    if (webcamVideo) {
      // Stop the webcam video stream
      webcamVideo.srcObject?.getTracks().forEach((track) => track.stop());
    }
  };
  const [zoom, setZoom] = useState(1);

  const handleZoomIn = () => {
    setZoom(zoom + 0.1);
  };

  const handleZoomOut = () => {
    setZoom(zoom - 0.1);
  };

  const startWebcamStream = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      if (webcamRef.current) {
        webcamRef.current.video.srcObject = stream;
      }
    } catch (error) {
      console.error("Error starting webcam stream:", error);
    }
  };

  const [RuntimeConfigs, setRuntimeConfigs] = React.useState([]);
  // const getRuntimeConfigsApi = useCallback(() => {
  //   RuntimeConfigsApi.ListRuntimeConfigs()
  //     .then((response) => {
  //       console.log("curr config :" + response.payloadDto)
  //       setRuntimeConfigs(response.payloadDto.filter(item => item?.tag === 'CURRENCY_TYPE_CONFIG'));
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
    getDepartments();
    getStorages();
    // getRuntimeConfigsApi();
    getAllergens();
    getShelfLifes();
    formAdd.setFieldsValue({
      unitOfMeasurement1: 1,
    });
    getCoolingShelfLifes();
    getStorage();
  }, [getDepartments, getStorage, getAllergens, getShelfLifes, getCoolingShelfLifes]);

  const validateInputNumber = (_, value) => {
    //  if (value >= 0 || value === 0 || value === null || value === undefined || value === '' || value === 0.00) {
    //       return Promise.resolve();
    //     }
    //     return Promise.reject(new Error("Value must be greater than to 0"));
    if (value < 0) {
      return Promise.reject(new Error("Value must be greater than to 0"));
    }

    return Promise.resolve();

  };

  const [coolingShelfResponse, setCoolingShelfResponse] = useState(null);

  const handleCoolingShelfResponse = (response) => {
    setCoolingShelfResponse(response);
  };

  const [ShelfResponse, setShelfResponse] = useState(null);

  const handleShelfResponse = (response) => {
    setShelfResponse(response);
  };

  const [StorageSuggestionResponse, setStorageSuggestionResponse] = useState(null);

  const handleStorageSuggestionResponse = (response) => {
    setStorageSuggestionResponse(response);
    console.log(response)
  };

  const [StorageResponse, setStorageResponse] = useState(null);
  const handleStorageResponse = (response) => {
    setStorageResponse(response);
    console.log(response)
  };

 const handleSubmit = (data) => {
  let productCode = data.productCode;
  if (productCode && productCode.startsWith('01')) {
    const codeWithoutPrefix = productCode.substring(2);
    productCode = codeWithoutPrefix.substring(0, 14);
  }

  const uom3 = data.unitOfMeasurement3 || 1;
  const unit3 = data.unit3 || "PIECE";
  const costUom3 = isNaN(data.costPriceUoM3) || data.costPriceUoM3 === null ? data.costPriceUoM2 : data.costPriceUoM3;

  const SelectDate = dayjs(data.createDate).format("DD/MM/YYYY");
  const allergenNames = Allergens
    .filter(item => data?.Allergen.includes(item.id))
    .map(item => item.allergensName)
    .join(',');

  // Get the list of supplier IDs
  const supplierIds = data.supplierId || [];
  
  // If no suppliers, show error
  if (supplierIds.length === 0) {
    notification.open({
      message: <span style={{ fontWeight: "bold" }}>Error</span>,
      description: "Please select at least one supplier",
      closeIcon: false,
      duration: 3,
      style: {
        backgroundColor: "#fff2f0",
        color: "red",
      },
    });
    return;
  }

  // Track which suppliers have been processed
  let processedCount = 0;
  let hasError = false;

  // Create product for each supplier
  selectedSuppliers.forEach((supplier) => {
    let formData = JSON.stringify({
      createdDate: convertToUnixTimestamp(SelectDate),
      productCode: productCode,
      productName: data.productName ,
      productCreateDate: convertToUnixTimestamp(SelectDate),
      unitOfMeasurement1: data.unitOfMeasurement1,
      unitOfMeasurement2: data.unitOfMeasurement2,
      unitOfMeasurement3: uom3,
      supplierDTO: [{ id: supplier.id }],
      allergens: data.Allergen.map((number) => ({ id: number })),
      currency: CURRENCY,
      unitUomOne: data.unit,
      unitUomTwo: data.unit2,
      unitUomThree: unit3,
      costPriceUoM1: data.costPriceUoM1,
      costPriceUoM2: data.costPriceUoM2,
      costPriceUoM3: costUom3,
      sellingPriceUoM1: 0.00,
      allergen: data?.Allergen?.join(','),
      sellingPriceUoM2: 0.00,
      sellingPriceUoM3: 0.00,
      department: '',
      shelfLifeDTO: (data?.ShelfLifeID) ? {
        id: ShelfResponse?.id,
        period: ShelfResponse?.period,
        periodType: ShelfResponse?.periodType,
        tenantDTO: {
          id: ShelfResponse?.tenantDTO?.id,
          tenantApiKey: ShelfResponse?.tenantDTO?.tenantApiKey,
        },
      } : null,
      allergensDTO: {
        id: data?.Allergen[0],
      },
      coolingShelfLifeDTO: (data?.CoolingShelfLifeID) ? {
        id: coolingShelfResponse?.id,
        period: coolingShelfResponse?.period,
        periodType: coolingShelfResponse?.periodType,
        temperatureInCelsius: coolingShelfResponse?.temperatureInCelsius,
        tenantDTO: {
          id: coolingShelfResponse?.tenantDTO?.id,
          tenantApiKey: coolingShelfResponse?.tenantDTO?.tenantApiKey,
        },
      } : null,
      storageSuggestionDTO: {
        id: StorageSuggestionResponse?.id,
        description: StorageSuggestionResponse?.description,
        name: StorageSuggestionResponse?.name,
        tenantDTO: {
          id: StorageSuggestionResponse?.tenantDTO?.id,
          tenantApiKey: StorageSuggestionResponse?.tenantDTO?.tenantApiKey,
        },
      },
      storageDTO: {
        id: StorageResponse?.id,
      },
      institutionDTO: {
        id: data.institutionId,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    ProductApi.CreateProduct(formData)
      .then((response) => {
        processedCount++;
        
        // Check if all suppliers have been processed
        if (processedCount === supplierIds.length && !hasError) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
            description: `All ${supplierIds.length} products created successfully`,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      })
      .catch((err) => {
        hasError = true;
        processedCount++;
        console.log(err);
        
        if (err?.apiError?.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err?.apiError?.status}</span>
            ),
            description: `Error for supplier ${supplier.supplierName}: ${err.apiError.message}`,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }

        // If all processing is complete and there was an error
        if (processedCount === supplierIds.length) {
          setLoadings(false);
        }
      });
  });
};

  function convertToUnixTimestamp(dateString) {
    const parts = dateString.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

      const unixTimestamp = Date.UTC(year, month, day);
    return unixTimestamp;
  }
  const currentDate = moment().format("DD/MM/YYYY");

  const [isModalproduct, setIsModalProduct] = useState(false);

  const showModal = () => {
    startWebcamStream();
    setIsModalProduct(true);
  };
  const handleOk = () => {
    setIsModalProduct(false);
  };
  const handleCancelProduct = () => {
    stopWebcamStream();
    setSrc(null);
    setisCameraOn(true);
    form.resetFields();
    setIsModalProduct(false);
  };
  const handleCancel = () => {
    formAdd.resetFields();
    onClose();
  };

  // OCR

  const cropperRef = useRef(null);
  const [src, setSrc] = useState(null);
  const [selectedOption, setSelectedOption] = useState("PName");
  const [loadings, setLoadings] = useState(false);
  const [rotation, setRotation] = useState(0);
  const onSelectFile = (e) => {
    setisCameraOn(false);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => setSrc(reader.result);
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  const [selectedPName, setPName] = useState("");
  const [selectedBarCode, setBarCode] = useState("");
  const [selectedOUBD, setOUBD] = useState("");
  const [selectedExpiry, setExpiry] = useState("");
  const handleRotate = () => {
    setRotation((prevRotation) => (prevRotation + 90) % 360);
  };

  const handleRightRotate = () => {
    setRotation((prevRotation) => (prevRotation + -90) % 360);
  };

  // Handler for cropping the image
  const handleCropComplete = (croppedArea, croppedAreaPixels) => {
    // Do something with the croppedArea and/or croppedAreaPixels data
  };
  const performOCR = async () => {
    setLoadings(true);
    if (!cropperRef.current) return;
    if (selectedOption) {
      const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
      const croppedImageBase64 = croppedCanvas.toDataURL("image/jpeg");
      try {
        const tesseractResult = await Tesseract.recognize(
          croppedImageBase64,
          "eng"
        );
        if (selectedOption === "PName") {
          setPName(tesseractResult.data.text);
          form.setFieldsValue({
            ProductName: tesseractResult.data.text,
          });
          setLoadings(false);
        } else if (selectedOption === "BarCode") {
          setBarCode(tesseractResult.data.text);
          form.setFieldsValue({
            BarCode: tesseractResult.data.text,
          });
          setLoadings(false);
        }
        // else if (selectedOption === "OUBD") {
        //   const defaultDate = moment(tesseractResult.data.text, "DD MMM YYYY");
        //   setOUBD(defaultDate);
        //   form.setFieldsValue({
        //     OCROUBD: defaultDate,
        //   });
        //   setLoadings(false);
        // }
        // else if (selectedOption === "Expiry") {
        //   const defaultDate = moment(tesseractResult.data.text, "DD MMM YYYY");
        //   setExpiry(defaultDate);
        //   form.setFieldsValue({
        //     OCREXPIRY: defaultDate,
        //   });
        //   setLoadings(false);
        // }
      } catch (error) {
        console.error("OCR Error:", error);
      }
    } else {
      setLoadings(false);
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>Error</span>,
        description: "Select Field",
        closeIcon: false,
        duration: 3,
        style: {
          backgroundColor: "#fff2f0",
          color: "red",
        },
      });
    }
  };

  const webcamRef = useRef(null);
  const [isCameraOn, setisCameraOn] = useState(true);

  const captureImage = () => {
    const video = webcamRef?.current?.video;
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    const dataURL = canvas.toDataURL("image/jpeg");
    setSrc(dataURL);
    setisCameraOn(false);
  };

  const CameraOn = () => {
    setSrc(null);
    setisCameraOn(true);
  };

  const SaveAddForm = () => {
    setIsModalProduct(false);
    formAdd.setFieldsValue({
      productName: selectedPName,
      productCode: selectedBarCode,
      OUBD: selectedOUBD,
      expiryDate: selectedExpiry,
    });
  };

  const [SelectShelfLife, setSelectShelfLife] = useState();
  const handleSelectChangeShelfLife = (value) => {

    const selectedOption = ShelfLife.find(option => option.id === value);
    setSelectShelfLife(selectedOption)
  };


  const [SelectCoolingShelfLife, setSelectCoolingShelfLife] = useState();
  const handleSelectChangeCoolingShelfLife = (value) => {

    const selectedOption = CoolingShelfLife.find(option => option.id === value);
    setSelectCoolingShelfLife(selectedOption)
  };


  const [SelectStorages, setSelectStorages] = useState();
  const handleSelectChangeStorages = (value) => {

    const selectedOption = Storages.find(option => option.id === value);
    setSelectStorages(selectedOption)
  };

  const [ChangeUOM1, setChangeUOM1] = useState();
  const handleInputChange = (e) => {
    const currentCostPriceUoM1 = formAdd.getFieldValue('unitOfMeasurement1');
    const currentCostPriceUoM2 = formAdd.getFieldValue('unitOfMeasurement2');
    const currentCostPriceUoM3 = formAdd.getFieldValue('unitOfMeasurement3');
    if (currentCostPriceUoM1 && currentCostPriceUoM2 && currentCostPriceUoM3) {
      const costPriceUoM2 = e.target.value / currentCostPriceUoM2;
      const costPriceUoM3 = costPriceUoM2 / currentCostPriceUoM3;
      formAdd.setFieldsValue({
        costPriceUoM2: parseFloat(costPriceUoM2).toFixed(2),
        costPriceUoM3: parseFloat(costPriceUoM3).toFixed(2),
      });
    }
  };

  const recalcCosts = () => {
    const costPriceUoM1 = parseFloat(formAdd.getFieldValue('costPriceUoM1'));
    const uom2 = parseFloat(formAdd.getFieldValue('unitOfMeasurement2'));
    const uom3 = parseFloat(formAdd.getFieldValue('unitOfMeasurement3'));

    // if (!costPriceUoM1 || !uom2 || !uom3) return;
    if (!costPriceUoM1 || !uom2) return;

    const costPriceUoM2 = costPriceUoM1 / uom2;
    const costPriceUoM3 = costPriceUoM2 / uom3;

    formAdd.setFieldsValue({
      costPriceUoM2: costPriceUoM2.toFixed(2),
      costPriceUoM3: costPriceUoM3.toFixed(2),
    });
  };


  const handleInputChange2 = (e) => {
    const currentCostPriceUoM1 = formAdd.getFieldValue('unitOfMeasurement1');
    const currentCostPriceUoM2 = formAdd.getFieldValue('unitOfMeasurement2');
    if (currentCostPriceUoM1 && currentCostPriceUoM2) {
      const total = e.target.value / currentCostPriceUoM2;
      formAdd.setFieldsValue({
        sellingPriceUoM2: parseFloat(total).toFixed(2),
      });
    }
  };
  const handleChangeUOM1 = (value) => {
    setChangeUOM1(value)
  };
  const [isRecording, setIsRecording] = useState(false);
  const [isRecordingproductCode, setIsRecordingproductCode] = useState(false);

  const startRecording = (fieldN) => {
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      let fieldName = fieldN;

      formAdd.setFieldsValue({
        [fieldName]: transcript,
      });
    };

    recognition.start();
    if (fieldN === 'productCode') {
      setIsRecordingproductCode(true);
    } else if (fieldN === 'productName') {
      setIsRecording(true);
    }
  };

  const stopRecording = () => {
    setIsRecording(false);
    setIsRecordingproductCode(false);
  };
  return (
    <>
      <Modal
        footer={[]}
        width={600}
        visible={visible}
        onCancel={handleCancel}
        maskClosable={false}
        onOk={onClose}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          Individual Product
        </Title>
        <Form
          form={formAdd}
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          className="FormClass IndividualProduct-Model"
          onFinish={handleSubmit}
        >
          <>
            <div className="Product-createDate">
              <div className="mb-2" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                <b className="mx-2">{currentDate}</b>
                <img
                  src="/assest/Images/cal.png"
                  style={{ width: '32px' }}
                  className="logo-png"
                />
              </div>
              <Form.Item
                name="createDate"
                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                className="text-lable col-lg-6 col-sm-12 col-md-7 d-none"
                rules={[
                  {
                    required: true,
                    message: "Please enter Date.",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  className="form-control control-input"
                />
              </Form.Item>
            </div>
            {/* <Form.Item
              label=" "
              labelCol={{
                span: 8,
              }}
              className="text-lable"
            >
              <Button
                className="DrawerCard mx-0 mt-0"
                onClick={showModal}
                style={{ padding: "4px 27px", borderRadius: "8px" }}
              >
                OCR
              </Button>
            </Form.Item> */}
            <Form.Item
              name="productName"
              label="Product Name :"
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please enter Product Name.",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Product Name"
                className="control-input speachBtn  mb-0"
                style={{
                  border: 'none',
                }}
                addonAfter={
                  <Button
                    onMouseDown={() => startRecording('productName')}
                    onMouseUp={stopRecording}
                    onMouseLeave={stopRecording}
                    style={{
                      border: 'none',
                      padding: 0,
                      background: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                  </Button>
                }
              />
            </Form.Item>
            <Form.Item
              name="productCode"
              label="Barcode :"
              className="text-lable"
              rules={[
                {
                  required: false,
                  message: "Please enter Barcode.",
                },
                {
                  validator: (_, value) => {
                    if (value && /\s/.test(value)) {
                      return Promise.reject(new Error("Barcode cannot contain spaces"));
                    }
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <Input
                type="text"
                placeholder="Barcode"
                className="control-input speachBtn  mb-0"
                style={{
                  border: 'none',
                }}
                onChange={(e) => {
                  const noSpaces = e.target.value.replace(/\s/g, '');
                  formAdd.setFieldsValue({ productCode: noSpaces });
                }}
                addonAfter={
                  <Button
                    onMouseDown={() => startRecording('productCode')}
                    onMouseUp={stopRecording}
                    onMouseLeave={stopRecording}
                    style={{
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      background: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {isRecordingproductCode ? <LoadingOutlined /> : <AudioOutlined />}
                  </Button>
                }
              />
            </Form.Item>

            <div className="row product-row d-flex pt-1">

              <div className=" col-2"></div>
              <div className=" col-6">
                <Form.Item
                    name="unitOfMeasurement1"
                    label="UoM 1"
                    className="text-lable producectCol disabled"
                    rules={[
                      {
                        required: true,
                        message: "Please enter unit of measurement 1.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder= "UoM 1"
                      inputMode="decimal"
                      disabled
                      style={{ 
                        MozAppearance: 'textfield'
                      }}
                      className="control-input"
                      onKeyDown={(e) => {
                        const key = e.key;
                        const currentValue = e.target.value;
                        
                        // Allow control keys
                        const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 
                                            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                                            'Home', 'End'];
                        
                        if (controlKeys.includes(key)) {
                          return;
                        }
                        
                        // Allow numbers
                        if (/^[0-9]$/.test(key)) {
                          return;
                        }
                        
                        // Allow single decimal point
                        if (key === '.' && !currentValue.includes('.')) {
                          return;
                        }
                        
                        // Prevent everything else
                        e.preventDefault();
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Only allow numbers and single decimal point
                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                          formAdd.setFieldsValue({
                            unitOfMeasurement1: value === '' ? undefined : parseFloat(value) || 0
                          });
                        }
                      }}
                    />
                  </Form.Item>
              </div>
              <div className="col-4">
                <Form.Item
                  name="unit"
                  label="Unit"
                  className="text-lable producectCol"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Unit",
                    },
                  ]}
                >
                  <UOM1 />
                </Form.Item>
              </div>
              <div>
                <p style={{ textAlign: 'end', fontSize: '13px', color: 'blue' }}><InfoCircleFilled style={{ fontSize: '10px' }} className="inforIcon" />  Ex : 10 PACKETS are inside 1 BOX (UOM1 = 1 BOX and UOM2 = 10 PACKETS)</p>

              </div>
            </div>
            <div className="row product-row d-flex pt-1">

              <div className=" col-2"></div>
              <div className=" col-6">
                <Form.Item
                  name="unitOfMeasurement2"
                  label="UoM 2"
                  className="text-lable producectCol"
                  rules={[
                    {
                      required: true,
                      message: "Please enter unit of measurement 2.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder= "UoM 2"
                    inputMode="decimal"
                    style={{ 
                      MozAppearance: 'textfield'
                    }}
                    className="control-input"
                    onKeyDown={(e) => {
                      const key = e.key;
                      const currentValue = e.target.value;
                      
                      // Allow control keys
                      const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 
                                          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                                          'Home', 'End'];
                      
                      if (controlKeys.includes(key)) {
                        return;
                      }
                      
                      // Allow numbers
                      if (/^[0-9]$/.test(key)) {
                        return;
                      }
                      
                      // Allow single decimal point
                      if (key === '.' && !currentValue.includes('.')) {
                        return;
                      }
                      
                      // Prevent everything else
                      e.preventDefault();
                    }}
                   onChange={(e) => {
                    const value = e.target.value;

                    if (value === '' || /^\d*\.?\d*$/.test(value)) {
                      formAdd.setFieldsValue({
                        unitOfMeasurement2: value
                      });
                    }
                  }}
                  />
                </Form.Item>
              </div>
              <div className="col-4">
                <Form.Item
                  name="unit2"
                  label="Unit"
                  className="text-lable producectCol"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Unit",
                    },
                  ]}
                >
                  <UOM2 />
                </Form.Item>
              </div>
            </div>

            <div className="row product-row d-flex pt-1">

              <div className=" col-2"></div>
              <div className=" col-6">
               <Form.Item
                  name="unitOfMeasurement3"
                  label="UoM 3"
                  className="text-lable producectCol"
                  dependencies={['unit3']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const unit3 = getFieldValue('unit3');

                        // Both empty -> OK
                        if (!value && !unit3) {
                          return Promise.resolve();
                        }

                        // Both filled -> OK
                        if (value && unit3) {
                          return Promise.resolve();
                        }

                        // One empty, one filled -> Error
                        return Promise.reject(
                          new Error("Please fill BOTH UoM3 and Unit, or leave both empty.")
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    type="text"
                    placeholder= "UoM 3"
                    inputMode="decimal"
                    style={{ 
                      MozAppearance: 'textfield'
                    }}
                    className="control-input"
                    onKeyDown={(e) => {
                      const key = e.key;
                      const currentValue = e.target.value;
                      
                      // Allow control keys
                      const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 
                                          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                                          'Home', 'End'];
                      
                      if (controlKeys.includes(key)) {
                        return;
                      }
                      
                      // Allow numbers
                      if (/^[0-9]$/.test(key)) {
                        return;
                      }
                      
                      // Allow single decimal point
                      if (key === '.' && !currentValue.includes('.')) {
                        return;
                      }
                      
                      // Prevent everything else
                      e.preventDefault();
                    }}
                   onChange={(e) => {
                    const value = e.target.value;

                    if (value === '' || /^\d*\.?\d*$/.test(value)) {
                      formAdd.setFieldsValue({
                        unitOfMeasurement3: value
                      });

                      recalcCosts(e);
                    }
                  }}
                  />
                </Form.Item>
              </div>
              <div className="col-4">
                <Form.Item
                  name="unit3"
                  label="Unit"
                  className="text-lable producectCol"
                  dependencies={['unitOfMeasurement3']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const uom3 = getFieldValue('unitOfMeasurement3');

                        if (!value && !uom3) return Promise.resolve();
                        if (value && uom3) return Promise.resolve();

                        return Promise.reject(
                          new Error("Please fill BOTH UoM3 and Unit, or leave both empty.")
                        );
                      },
                    }),
                  ]}
                >
                  <UOM3 />
                </Form.Item>
              </div>
            </div>


            <Form.Item
              name="costPriceUoM1"
              label="Cost Price per UoM 1 :"
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please enter Cost Price per UoM 1.",
                },
                { validator: validateInputNumber },
              ]}
            >
              <Input
                type="text"
                inputMode="decimal"
                placeholder="0.00"
                className="control-input PriceClass"
                onChange={recalcCosts}
                style={{
                  border: 'none',
                  marginBottom: '0px',
                }}
                onKeyDown={(e) => {
                  const key = e.key;
                  const value = e.currentTarget.value;

                  // allow control keys
                  const controlKeys = [
                    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                    'ArrowLeft', 'ArrowRight', 'Home', 'End'
                  ];

                  if (controlKeys.includes(key)) return;

                  // allow numbers
                  if (/^[0-9]$/.test(key)) return;

                  // allow one decimal point
                  if (key === '.' && !value.includes('.')) return;

                  // block everything else
                  e.preventDefault();
                }}
                onPaste={(e) => {
                  const paste = e.clipboardData.getData('text');
                  if (!/^\d*\.?\d*$/.test(paste)) {
                    e.preventDefault();
                  }
                }}
                addonBefore={
                  <Button
                    style={{
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      background: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {CURRENCY}
                  </Button>
                }
              />
            </Form.Item>
            {/* <Form.Item
              name="sellingPriceUoM1"
              label="Selling Price UoM 1 :"
              className="text-lable PriceClass"
              rules={[
                {
                  required: true,
                  message: "Please enter Selling Price UoM 1.",
                },
                { validator: validateInputNumber },
              ]}
            >
              <Input
                type="number"
                placeholder="0.00"
                className="control-input"
                onChange={handleInputChange2}
                style={{
                  marginBottom: '0px',
                  border: 'none',
                }}
                addonBefore={
                  <Button
                    style={{
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      background: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {CURRENCY}
                  </Button>
                }
              />
            </Form.Item> */}


            <Form.Item
              name="costPriceUoM2"
              label="Cost Price per UoM 2 :"
              className="text-lable disabled"
              rules={[
                {
                  required: true,
                  message: "Please enter Cost Price per UoM 2.",
                },
                { validator: validateInputNumber },
              ]}
            >
             <Input
              disabled
              type="text"
              inputMode="decimal"
              placeholder="0.00"
              className="control-input PriceClass"
              style={{
                border: 'none',
                marginBottom: '0px',
              }}
              addonBefore={
                <Button
                  style={{
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    background: 'none',
                    cursor: 'default',
                  }}
                >
                  {CURRENCY}
                </Button>
              }
            />
            </Form.Item>

            <Form.Item
              name="costPriceUoM3"
              label="Cost Price per UoM 3 :"
              className="text-lable disabled"
              rules={[
                // {
                //   required: true,
                //   message: "Please enter Cost Price per UoM 3.",
                // },
                { validator: validateInputNumber },
              ]}
            >
              <Input
                disabled
                type="text"
                inputMode="decimal"
                placeholder="0.00"
                className="control-input PriceClass"
                style={{
                  border: 'none',
                  marginBottom: '0px',
                }}
                addonBefore={
                  <Button
                    style={{
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      background: 'none',
                      cursor: 'default',
                    }}
                  >
                    {CURRENCY}
                  </Button>
                }
              />
            </Form.Item>



            {/* <Form.Item
              name="sellingPriceUoM2"
              label="Selling Price UoM 2 :"
              className="text-lable disabled"
              rules={[
                {
                  required: true,
                  message: "Please enter Selling Price UoM 2.",
                },
                { validator: validateInputNumber },
              ]}
            >
              <Input
                disabled
                type="number"
                placeholder="0.00"
                className="control-input PriceClass"
                style={{
                  border: 'none',
                  marginBottom: '0px',
                }}
                addonBefore={
                  <Button
                    style={{
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      background: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {CURRENCY}
                  </Button>
                }
              />
            </Form.Item> */}

            <SupplierModel     onSupplierChange={setSelectedSuppliers}/>

            <DepartmentModel onChange={handleDepartmentChange} />

            <AllergenModel />

            <ShelfLifeModel onShelfResponse={handleShelfResponse} />
            <CoolingShelfModel onCoolingShelfResponse={handleCoolingShelfResponse} />


            <StorageSuggestionModel onStorageSuggestionResponse={handleStorageSuggestionResponse} />

            <StorageDropDown onStorageResponse={handleStorageResponse} />


            {/* <div className="d-flex justify-content-center pt-4">
              <Button
                type="primary"
                htmlType="submit"
                className="btn btn-primary btn-save mx-2"
                style={{ width: "37%" }}
              >
                Create
              </Button>
              <Link
                type="primary"
                to={""}
                className="btn btn-primary btn-back mx-2 w-20"
                style={{ width: "37%" }}
                onClick={handleCancel}
              >
                Cancel
              </Link>
            </div> */}

            <div
              className="d-flex justify-content-between pt-4"
              style={{
                gap: "10px",
                padding: "16px 24px 0", // aligns nicely with modal padding
              }}
            >
              <Button
                type="primary"
                htmlType="submit"
                // disabled={BtnDisable}
                style={{
                  flex: 1,
                  height: 40,
                  borderRadius: 6,
                }}
              >
                Create
              </Button>

              <Button
                onClick={handleCancel}
                style={{
                  flex: 1,
                  height: 40,
                  borderRadius: 6,
                }}
              >
                Cancel
              </Button>
            </div>
          </>
        </Form>
      </Modal>
      <Modal
        open={isModalproduct}
        width={1000}
        onOk={handleOk}
        onCancel={handleCancelProduct}
        footer={[]}
        maskClosable={false}
      >
        <div className="product-model text-center">
          <Title level={4} className="Primary-Font ">
            OCR SCAN
          </Title>
        </div>
        <div className=" product-OCR-model pt-3">
          <Row gutter={24}>
            <Col span={10}>
              <div className="d-flex justify-content-center pb-2">
                {isCameraOn && (
                  <CameraTwoTone className="OCR-icon px-4" onClick={CameraOn} />
                )}{" "}
                {!isCameraOn && (
                  <CameraOutlined
                    className="OCR-icon px-4"
                    onClick={CameraOn}
                  />
                )}
                <label htmlFor="UploadImage">
                  {src && (
                    <PictureTwoTone
                      className="OCR-icon px-4"
                      style={{ cursor: "pointer" }}
                    />
                  )}{" "}
                  {!src && (
                    <PictureOutlined
                      className="OCR-icon px-4"
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </label>
              </div>
              {isCameraOn && (
                <>
                  <p className="text-center pt-2">Preview</p>
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    style={{ width: "100%" }}
                    screenshotFormat="image/jpeg"
                    videoConstraints={{ facingMode: "environment" }}
                  />

                  <div className="d-flex justify-content-center">
                    <Button
                      type="button"
                      onClick={captureImage}
                      className="btn btn-primary btn-save mx-0 "
                      disabled={loadings}
                    >
                      Take a photo{loadings && <Spin className="px-2 pt-2" />}
                    </Button>
                  </div>
                </>
              )}

              {src && (
                <>
                  <p className="text-center pt-2">Preview Area</p>
                  <div className="d-flex justify-content-center pb-5">
                    <ZoomOutOutlined onClick={handleZoomOut} />
                    <ZoomInOutlined
                      onClick={handleZoomIn}
                      style={{ paddingRight: "10px" }}
                    />
                    <RotateLeftOutlined onClick={handleRotate} />
                    <RotateRightOutlined onClick={handleRightRotate} />
                  </div>
                  <Cropper
                    ref={cropperRef}
                    src={src}
                    zoomTo={zoom}
                    style={{
                      width: "100%",
                      height: "300px", // Set the desired height of the cropper
                      transform: `rotate(${rotation}deg)`,
                    }}
                  />

                  <br />
                  <div className="d-flex justify-content-center">
                    <Button
                      type="button"
                      onClick={performOCR}
                      className="btn btn-primary btn-save mx-0 "
                      disabled={loadings}
                    >
                      Scan {loadings && <Spin className="px-2 pt-2" />}
                    </Button>
                  </div>
                </>
              )}
              <input
                type="file"
                accept="image/*"
                id="UploadImage"
                style={{ visibility: "hidden" }}
                onChange={onSelectFile}
              />
            </Col>
            <Col span={6} >
              <Button
                type="button"
                style={{ height: "auto" }}
                className={`btn btn-primary  ${selectedOption === "PName" ? "btn-save" : "btn-back"
                  } mx-0`}
                disabled={selectedOption === "PName"}
                onClick={() => setSelectedOption("PName")}
              >
                Product Name
              </Button>
              <Button
                type="button"
                style={{ height: "auto" }}
                className={`btn btn-primary  ${selectedOption === "BarCode" ? "btn-save" : "btn-back"
                  } mx-0`}
                disabled={selectedOption === "BarCode"}
                onClick={() => setSelectedOption("BarCode")}
              >
                Barcode
              </Button>

              {/* <Button
                type="button"
                style={{ height: "auto" }}
                className={`btn btn-primary  ${selectedOption === "OUBD" ? "btn-save" : "btn-back"
                  } mx-0`}
                disabled={selectedOption === "OUBD"}
                onClick={() => setSelectedOption("OUBD")}
              >
                OUBD
              </Button>

              <Button
                type="button"
                style={{ height: "auto" }}
                className={`btn btn-primary  ${selectedOption === "Expiry" ? "btn-save" : "btn-back"
                  } mx-0`}
                disabled={selectedOption === "Expiry"}
                onClick={() => setSelectedOption("Expiry")}
              >
                Expiry Date
              </Button> */}
            </Col>
            <Col span={8}>
              <Form
                form={form}
                name="nest-messages"
                className="FormClass IndividualProduct-Model"
                labelCol={{
                  span: 24,
                }}
                wrapperCol={{
                  span: 24,
                }}
                onFinish={SaveAddForm}
              >
                <Form.Item
                  name="ProductName"
                  label="Product Name"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Product Name.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Captured Product Name"
                    className="control-input"
                  />
                </Form.Item>

                <Form.Item
                  name="BarCode"
                  label="BarCode"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please enter BarCode.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Captured barcode"
                    className="control-input"
                  />
                </Form.Item>
                {/* <Form.Item
                  name="OCROUBD"
                  label="OUBD"
                  className="text-lable"                  
                >
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    placeholder="Select OUBD"
                    className="form-control control-input"
                  />
                </Form.Item>

                <Form.Item
                  name="OCREXPIRY"
                  label="Expiry Date"
                  className="text-lable"                 
                >
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    placeholder="Select Expiry Date"
                    className="form-control control-input"
                  />
                </Form.Item> */}
                <div className="d-flex justify-content-center">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="btn btn-primary btn-save mx-0 "
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
}

export default AddProduct;
